import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'account.subscription.title',
    defaultMessage: 'Subscription',
  },
  empty: {
    id: 'account.subscription.empty',
    defaultMessage: 'You do not currently have any subscriptions.',
  },
  manageButton: {
    id: 'account.subscription.manageButton',
    defaultMessage: 'Manage my subscription(s)',
  },
  infoButton: {
    id: 'account.subscription.infoButton',
    defaultMessage: 'subscription info',
  },
  active: {
    id: 'account.subscription.active',
    defaultMessage: 'Your next payment is due on ',
  },
  trial: {
    id: 'account.subscription.trial',
    defaultMessage: 'Your free trial expires on',
  },
  account: {
    id: 'components.steps.subscription.account',
    defaultMessage: 'Account',
  },
  address: {
    id: 'components.Steps.address',
    defaultMessage: 'Address',
  },
  payment: {
    id: 'components.steps.subscription.payment',
    defaultMessage: 'Payment',
  },
  expiring: {
    id: 'account.subscription.expiring',
    defaultMessage:
      'Your products will remain active until your subscription expires on',
  },
  cancelled: {
    id: 'account.subscription.cancelled',
    defaultMessage: 'Your subscription expired on',
  },
  statusActive: {
    id: 'account.subscription.status.active',
    defaultMessage: 'Active',
  },
  statusTrial: {
    id: 'account.subscription.status.trial',
    defaultMessage: 'Free trial',
  },
  statusCancelled: {
    id: 'account.subscription.status.cancelled',
    defaultMessage: 'cancelled',
  },
  statusExpiring: {
    id: 'account.subscription.status.expiring',
    defaultMessage: 'expiring',
  },
  cancelledLink: {
    id: 'account.subscription.cancelledLink',
    defaultMessage: 'click here.',
  },
  genericErrorTitle: {
    id: 'errors.subscription.oops',
    defaultMessage: 'Oops! Something went wrong!',
  },
  genericErrorMessage: {
    id: 'errors.subscription.ErrorProcessing',
    defaultMessage:
      'We encountered an error processing your request. Please continue with one of the following options:',
  },
  genericErrorAccountButton: {
    id: 'account.title',
    defaultMessage: 'My Account',
  },
  genericError360TrialButton: {
    id: 'errors.subscription.FreeTrial',
    defaultMessage: '360 free trial',
  },
  genericErrorSupportMessage: {
    id: 'errors.subscription.ErrorContinues',
    defaultMessage:
      'If you continue to encounter this error, please {customerSupportLink}.',
  },
  customerSupportLink: {
    id: 'errors.subscription.ContactSupport',
    defaultMessage: 'contact customer support',
  },
  cancelCta: {
    id: 'account.subscription.cancelCta',
    defaultMessage: 'Cancel',
  },
  reactivate: {
    id: 'account.subscription.reactivate',
    defaultMessage: 'Reactivate',
  },
  cancelHeading: {
    id: 'account.subscription.cancelHeading',
    defaultMessage: 'Cancel {product}',
  },
  expireOn: {
    id: 'account.subscription.expireOn',
    defaultMessage: 'Your subscription will expire on {date}',
  },
  cancellationReason: {
    id: 'account.subscription.cancellationReason',
    defaultMessage: 'Why are you cancelling your subscription?',
  },
  otherReasons: {
    id: 'account.subscription.otherReasons',
    defaultMessage: 'Is there anything else you would like to let us know?',
  },
  confirmCancellation: {
    id: 'account.subscription.confirmCancellation',
    defaultMessage: 'Confirm cancellation',
  },
  updateError: {
    id: 'account.subscription.updateError',
    defaultMessage:
      'There has been an error while trying to cancel your subscription.{br}{br}Please try again, if this issue persists contact {customerSupportUrl}.',
  },
  customerSupport: {
    id: 'customerSupport',
    defaultMessage: 'customer support',
  },
  updateSucces: {
    id: 'account.subscription.updateSuccess',
    defaultMessage:
      'We have received your cancellation request.{br}{br}This page will automatically refresh in 3 seconds.',
  },
  missingReasonError: {
    id: 'account.subscription.missingReasonError',
    defaultMessage:
      'Please make a selection to continue with your cancellation',
  },
  changePlan: {
    id: 'account.subscription.changePlan',
    defaultMessage: 'Change plan',
  },
  updatePaymentMethod: {
    id: 'account.subscription.updatePaymentMethod',
    defaultMessage: 'Update payment method',
  },
  paymentMethod: {
    id: 'account.subscription.paymentMethod',
    defaultMessage: 'Payment method',
  },
  nextPayment: {
    id: 'account.subscription.nextPayment',
    defaultMessage: 'Next payment',
  },
  successSurveyTitle: {
    id: 'account.subscription.success.survey.title',
    defaultMessage: 'Payment successful',
  },
  successSurveyMessage: {
    id: 'account.subscription.success.survey.message',
    defaultMessage:
      'Tell us about yourself to personalise your browsing and learning experience.',
  },
  downgradeSuccessful: {
    id: 'account.subscription.downgradeSuccessful',
    defaultMessage:
      'The requested plan change was successful. Some changes might be only visible on the next billing cycle.',
  },
  upgradeSuccessful: {
    id: 'account.subscription.upgradeSuccessful',
    defaultMessage: 'The requested plan change was successful.',
  },
  alreadySubscribedAlert: {
    id: 'errors.subscription.subscribed',
    defaultMessage:
      'You are already subscribed. You can manage your subscription below.',
  },
  reactivationErrorAlert: {
    id: 'errors.subscription.reactivationError',
    defaultMessage:
      'We couldn’t reactivate your subscription, possibly due to an outdated payment method. Please update it via the ‘Manage my subscription’ button below, save the changes, and then try reactivating again from this page. If the issue persists, contact our support team.',
  },
  customerSupportAlertLink: {
    id: 'account.supportTitle',
    defaultMessage: 'Customer Support',
  },
});
